<template>
    <v-menu open-on-hover left offset-x>
        <template v-slot:activator="{ on }">
            <v-chip :color="getSaleStatus(sale.statusdetail, 'color')" class="my-1" label small dark v-on="on">
                Réservation - {{ getSaleStatus(sale.statusdetail, 'label') }}
            </v-chip>

            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-chip v-if="sale.count > 1" label small class="ml-1" v-on="on">
                        + {{ sale.count - 1 }}
                    </v-chip>
                </template>
                Vous avez passé {{ sale.count - 1}} autre{{ sale.count > 2 ? 's' : '' }} réservation{{ sale.count > 2 ? 's' : '' }} sur ce lot
            </v-tooltip>
        </template>

        <v-card>
            <v-card-title :class="`py-1 white--text subtitle ${getSaleStatus(sale.statusdetail, 'color')}`">
                {{ getSaleStatus(sale.statusdetail, 'label') }}
            </v-card-title>

            <v-list dense>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ sale.activityDate | toDate() }} à {{ sale.activityDate | toTime() }}
                        </v-list-item-title>

                        <v-list-item-subtitle>
                            Date de création
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ sale.contact.name }} {{ sale.contact.firstname }}
                        </v-list-item-title>

                        <v-list-item-subtitle>
                            Contact
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ sale.statusdate | toDate() }} à {{ sale.statusdate | toTime() }}
                        </v-list-item-title>

                        <v-list-item-subtitle>
                            {{ getSaleStatus(sale.statusdetail, 'statusDateLabel') }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script>
import salesMixin from '../../mixins/sales.js';

export default {
    name: 'ProductSaleChip',

    mixins: [salesMixin],

    props: {
        product: { type: Object },
        sale: { type: Object }
    }
};
</script>
